<template>
  <div class="DarkWhite pa-4 ">
      <h2 class="subheading green--text">Mode of Procurement</h2>
      <v-card class="mt-4">
      <PSUMOP/>
  </v-card>
  </div>
</template>

<script>
import PSUMOP from '../components/Utils/PSUMOP.vue'
  export default {
    components: {
       PSUMOP
    },
    data: () => ({
    }),
  }
</script>


<style scoped>
</style>